import { render, staticRenderFns } from "./PreventivoHome.vue?vue&type=template&id=65dbb7bf&"
import script from "./PreventivoHome.vue?vue&type=script&lang=js&"
export * from "./PreventivoHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports